module.exports = __webpack_public_path__ + "img/tabo-dapple.b3d738cc.png";